module.exports = __webpack_public_path__ + "img/transmitter.2840f03a.png";